// Browser-side client spans.
//
// timing-link already stamps a W3C traceparent on every GraphQL fetch, so
// server spans parent under browser-minted ids. These helpers materialize
// those ids as real spans: minimal { trace_id, span_id, start, end } records
// shipped through the authenticated web-perf beacon and relayed to the OTel
// collector by the API (client-span-relay.ts). No OTel Web SDK: the ids and
// two timestamps are the whole contract.

export const randomHex = (byteLength: number): string =>
  Array.from(crypto.getRandomValues(new Uint8Array(byteLength)))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')

// Span names live in the shared wire contract: WebClientSpanName in
// @doss/common-all web-telemetry-events.ts.

/** One browser trace: a root span id everything in the trace parents under. */
export type ClientTraceContext = {
  traceId: string
  rootSpanId: string
}

export const newClientTraceContext = (): ClientTraceContext => ({
  traceId: randomHex(16),
  rootSpanId: randomHex(8),
})

export const newSpanId = (): string => randomHex(8)

/** W3C trace context header parenting a server request under `spanId`. */
export const buildTraceparent = (traceId: string, spanId: string): string =>
  `00-${traceId}-${spanId}-01`
